import merge from 'lodash/merge'

import {
	FETCH_LOYALTY_RATES_BEGIN,
	FETCH_LOYALTY_RATES_SUCCESS,
	FETCH_LOYALTY_RATES_FAILURE
} from '../actions/fetchLoyaltyRates'

const initialState = {
	loading: false,
	error: null,
	availability: null
}

export default function fetchLoyaltyRatesReducers(state = initialState, action) {
	switch(action.type) {
		case FETCH_LOYALTY_RATES_BEGIN:
			return {
				...state,
				loading: true,
				error: null
			}

		case FETCH_LOYALTY_RATES_SUCCESS:
			return {
				...state,
				loading: false,
				availability: merge({}, state.availability, action.payload)
			}

		case FETCH_LOYALTY_RATES_FAILURE:
			return {
				...state,
				loading: false,
				error: action.payload.error,
				availability: null,
			}

		default:
			return state;
	}
}


// WEBPACK FOOTER //
// ./src/reducers/fetchLoyaltyRatesReducers.js